import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { HttpClient, HttpRequest, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';
import { tokenInterceptor } from './shared/interceptors/token.interceptor';
import { httpLogInterceptor } from './shared/interceptors/http-log.interceptor';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
import { ConfigService } from './shared/services/config.service';
import { provideTranslateService } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// Configura tutte le richieste che non devono essere bloccate da BlockUI
export function filtroBlockUI(req: HttpRequest<any>): boolean {
	if (req.url.includes('noBlock')) {
		return true;
	}
	return false;
}

export function configServiceFactory(http: HttpClient, configService: ConfigService) {
	return () => configService.load(http);
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes, withComponentInputBinding()),
		provideHttpClient(withInterceptors([tokenInterceptor, httpLogInterceptor, errorInterceptor])),
		provideAppInitializer(() => {
			const initializerFn = configServiceFactory(inject(HttpClient), inject(ConfigService));
			return initializerFn();
		}),
		provideTranslateService({ loader: { provide: TranslateLoader, useFactory: createTranslateLoader, deps: [HttpClient] } }),
		importProvidersFrom(BlockUIModule.forRoot(), BlockUIHttpModule.forRoot({ requestFilters: [filtroBlockUI] })),
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler(),
		},
	],
};
